import { status } from '@/alas';
import { defineComponent, reactive, ref, computed, onMounted, watch } from '@vue/composition-api';
export default defineComponent({
    props: {
        picture: {}
    },
    setup($p) {
        // ================
        //
        // refs
        //
        let card = ref(null);
        // ================
        //
        // state
        //
        let $ = reactive({
            type: null,
            breed: null,
            height: 0,
            types: status.fetch('types'),
            config: status.fetch('config')
        });
        // ================
        //
        // watch
        //
        watch(() => $p.picture, () => {
            card.value.$el.scrollTo(0, 0);
        });
        // ================
        //
        // computed
        //
        let image = computed(() => $p.picture.$v.miniImage);
        let fullImage = computed(() => $p.picture.$v.image);
        let avgTemperature = computed(() => {
            let t = $p.picture.weather.lowTemperature + $p.picture.weather.highTemperature;
            return (t / 2).toFixed(1);
        });
        let tags = computed(() => {
            let tags = [];
            for (let tag of $p.picture.tags) {
                let { name, color } = $.type.tags.fetch(tag);
                tags.push({ name, color });
            }
            return tags;
        });
        let events = computed(() => {
            let type = $.type;
            let output = [];
            let events = $p.picture.$m.getEventsDetail(type);
            for (let event of events) {
                output.push({
                    name: event.type.name,
                    color: event.type.color,
                    images: event.images,
                    message: event.message
                });
            }
            return output;
        });
        // ================
        //
        // mounted
        //
        onMounted(() => {
            $.types.o.fetch.seek().then(() => {
                $.type = $.types.fetch($p.picture.type);
                $.breed = $.type.breeds.fetch($p.picture.breed);
            });
        });
        // ================
        //
        // methods
        //
        let getRevenuesName = (key) => {
            return $.config.revenueTypes.find(item => item.key === key).text;
        };
        // ================
        //
        // done
        //
        return {
            $,
            card,
            tags,
            image,
            fullImage,
            events,
            avgTemperature,
            getRevenuesName
        };
    }
});
